import React from "react";
import Home from "../pages/Home";
import Register from "../pages/Register";
import RegisterMultiStep from "../components/MultiStep/RegisterMultiStep";
import VirtualPassGenerator from "../components/MultiStep/VirtualPassGenerator";
import SuccessPage from "../pages/SuccessPage";
import Brochure from "../pages/Brochure";
import Admin from "../pages/Admin";
import AdminAnalysis from "../pages/AdminAnalysis";

const routes = [
    {
        element: <Home/>,
        path: '/'
    },
    {
        element: <Register/>,
        path: '/register'
    },
    {
        element: <RegisterMultiStep/>,
        path: '/survey'
    },
    {
        element: <VirtualPassGenerator/>,
        path: '/hc-pass'
    },
    {
        element: <SuccessPage/>,
        path: '/success'
    },
    {
        element: <Brochure/>,
        path: '/brochure'
    },
    {
        element: <Admin/>,
        path: '/admin'
    },
    {
        element: <AdminAnalysis/>,
        path: '/admin/analysis'
    },
]

export default routes
